import { PATTERNS } from '../../../constants/validations';
import { PASSWORD_STATUS } from '../../../constants/passwordRules';

export function validateUsernameLength(value) {
  return value && value.length >= 3 && value.length <= 40;
}

export function validateUsernameCharacters(value) {
  return PATTERNS.USERNAME_CHARACTERS.test(value);
}

export function validateUsernameRepeating(value) {
  return PATTERNS.USERNAME_REPEATING.test(value);
}

export function validateUsernameSpaces(value) {
  return PATTERNS.USERNAME_NO_SPACES.test(value);
}

export function getUsernameTooltipOptions(value) {
  let liStatus1 = PASSWORD_STATUS.DEFAULT;
  let liStatus2 = PASSWORD_STATUS.DEFAULT;
  let liStatus3 = PASSWORD_STATUS.DEFAULT;

  if (value) {
    if (validateUsernameCharacters(value)) {
      liStatus1 = PASSWORD_STATUS.DONE;
    } else {
      liStatus1 = PASSWORD_STATUS.DANGER;
    }

    if (validateUsernameRepeating(value)) {
      liStatus2 = PASSWORD_STATUS.DONE;
    } else {
      liStatus2 = PASSWORD_STATUS.DANGER;
    }

    if (validateUsernameSpaces(value)) {
      liStatus3 = PASSWORD_STATUS.DONE;
    } else {
      liStatus3 = PASSWORD_STATUS.DANGER;
    }
  }

  return [
    {
      rule: PATTERNS.USERNAME_CHARACTERS,
      title: 'auth.signup.popover.li1',
      status: liStatus1,
    },
    {
      rule: PATTERNS.USERNAME_REPEATING,
      title: 'auth.signup.popover.li2',
      status: liStatus2,
    },
    {
      rule: PATTERNS.USERNAME_NO_SPACES,
      title: 'auth.signup.popover.li3',
      status: liStatus3,
    },
  ];
}



// WEBPACK FOOTER //
// ./src/components/Auth/utils/usernameValidation.js